import apiFetch from '../../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `GrupoVerraco/getFiltrarGrupoVerracoSinAsignar`, method: 'POST', body: values, token: token})
}
